export type DashboardUnreadResource = 'contacts' | 'forms'

function storageKey(projectId: string, resource: DashboardUnreadResource): string {
  return `veltica:dashboard-seen:${projectId}:${resource}`
}

/** Estado local y deliberadamente liviano; no sustituye un read receipt del backend. */
export function readDashboardSeenIds(projectId: string, resource: DashboardUnreadResource): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const value: unknown = JSON.parse(window.localStorage.getItem(storageKey(projectId, resource)) ?? '[]')
    if (!Array.isArray(value)) return new Set()
    return new Set((value as unknown[]).filter((id): id is string => typeof id === 'string'))
  } catch {
    return new Set()
  }
}

export function markDashboardItemsSeen(projectId: string, resource: DashboardUnreadResource, ids: string[]): void {
  if (typeof window === 'undefined' || ids.length === 0) return
  const seen = readDashboardSeenIds(projectId, resource)
  ids.forEach((id) => seen.add(id))
  try {
    // Evita que una cuenta con mucho tráfico haga crecer localStorage sin límite.
    window.localStorage.setItem(storageKey(projectId, resource), JSON.stringify([...seen].slice(-500)))
  } catch {
    // El indicador es progresivo; la interfaz sigue funcionando sin storage.
  }
}
